/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransportLot
 */
export interface TransportLot {
    /**
     * 
     * @type {number}
     * @memberof TransportLot
     */
    companyId: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransportLot
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransportLot
     */
    orgSupplierId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TransportLot
     */
    recDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof TransportLot
     */
    transportLotNo: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransportLot
     */
    itemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransportLot
     */
    orgItemCode: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransportLot
     */
    minLoadCapacity: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransportLot
     */
    orderTransportTypeId: number | null;
    /**
     * 
     * @type {Date}
     * @memberof TransportLot
     */
    orderDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof TransportLot
     */
    lotQuantity: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransportLot
     */
    weight: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransportLot
     */
    maxPalletQuantity: number | null;
    /**
     * 
     * @type {Date}
     * @memberof TransportLot
     */
    orderDatePrev: Date | null;
    /**
     * 
     * @type {number}
     * @memberof TransportLot
     */
    lotQuantityPrev: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransportLot
     */
    remarks: string | null;
}

/**
 * Check if a given object implements the TransportLot interface.
 */
export function instanceOfTransportLot(value: object): value is TransportLot {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('orgSupplierId' in value) || value['orgSupplierId'] === undefined) return false;
    if (!('recDate' in value) || value['recDate'] === undefined) return false;
    if (!('transportLotNo' in value) || value['transportLotNo'] === undefined) return false;
    if (!('itemCode' in value) || value['itemCode'] === undefined) return false;
    if (!('orgItemCode' in value) || value['orgItemCode'] === undefined) return false;
    if (!('minLoadCapacity' in value) || value['minLoadCapacity'] === undefined) return false;
    if (!('orderTransportTypeId' in value) || value['orderTransportTypeId'] === undefined) return false;
    if (!('orderDate' in value) || value['orderDate'] === undefined) return false;
    if (!('lotQuantity' in value) || value['lotQuantity'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('maxPalletQuantity' in value) || value['maxPalletQuantity'] === undefined) return false;
    if (!('orderDatePrev' in value) || value['orderDatePrev'] === undefined) return false;
    if (!('lotQuantityPrev' in value) || value['lotQuantityPrev'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    return true;
}

export function TransportLotFromJSON(json: any): TransportLot {
    return TransportLotFromJSONTyped(json, false);
}

export function TransportLotFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportLot {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'orgSupplierId': json['org_supplier_id'],
        'recDate': (json['rec_date'] == null ? null : new Date(json['rec_date'])),
        'transportLotNo': json['transport_lot_no'],
        'itemCode': json['item_code'],
        'orgItemCode': json['org_item_code'],
        'minLoadCapacity': json['min_load_capacity'],
        'orderTransportTypeId': json['order_transport_type_id'],
        'orderDate': (json['order_date'] == null ? null : new Date(json['order_date'])),
        'lotQuantity': json['lot_quantity'],
        'weight': json['weight'],
        'maxPalletQuantity': json['max_pallet_quantity'],
        'orderDatePrev': (json['order_date_prev'] == null ? null : new Date(json['order_date_prev'])),
        'lotQuantityPrev': json['lot_quantity_prev'],
        'remarks': json['remarks'],
    };
}

export function TransportLotToJSON(json: any): TransportLot {
    return TransportLotToJSONTyped(json, false);
}

export function TransportLotToJSONTyped(value?: TransportLot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'org_supplier_id': value['orgSupplierId'],
        'rec_date': value['recDate'] == null ? value['recDate'] : value['recDate'].toISOString(),
        'transport_lot_no': value['transportLotNo'],
        'item_code': value['itemCode'],
        'org_item_code': value['orgItemCode'],
        'min_load_capacity': value['minLoadCapacity'],
        'order_transport_type_id': value['orderTransportTypeId'],
        'order_date': value['orderDate'] == null ? value['orderDate'] : value['orderDate'].toISOString(),
        'lot_quantity': value['lotQuantity'],
        'weight': value['weight'],
        'max_pallet_quantity': value['maxPalletQuantity'],
        'order_date_prev': value['orderDatePrev'] == null ? value['orderDatePrev'] : value['orderDatePrev'].toISOString(),
        'lot_quantity_prev': value['lotQuantityPrev'],
        'remarks': value['remarks'],
    };
}

